module.exports = "/images/joyride-note-white.png";